import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const ChevronUp: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M2.291 9.44043C1.90152 9.832 1.90322 10.4652 2.2948 10.8546C2.68637 11.2441 3.31953 11.2424 3.70901 10.8508L2.291 9.44043ZM8 5.11868L8.70901 4.41347C8.52132 4.22477 8.26615 4.11868 8 4.11868C7.73385 4.11868 7.47868 4.22477 7.291 4.41347L8 5.11868ZM12.291 10.8508C12.6805 11.2424 13.3136 11.2441 13.7052 10.8546C14.0968 10.4652 14.0985 9.832 13.709 9.44043L12.291 10.8508ZM3.70901 10.8508L8.70901 5.82388L7.291 4.41347L2.291 9.44043L3.70901 10.8508ZM7.291 5.82388L12.291 10.8508L13.709 9.44043L8.70901 4.41347L7.291 5.82388Z" />
  </SvgIcon>
);
